import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { SharedModule } from '@app/shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { UserService } from '@app/core/services/user.service';

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    HttpModule,
    HttpClientModule,
    SharedModule
  ],
  declarations: [AuthComponent, LoginComponent],
  providers: [],
})
export class AuthModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/auth/auth.module.ts